/* Sticky bar engagement — style msv-options */
(function() {
  function init() {
    var sb = document.querySelector('.status-bar-sign-up');
    var w = document.querySelector('#recharge-bundles');
    var sf = document.querySelector('.rb-sticky-form');
    if (!sb || !w || !sf) return setTimeout(init, 500);

    var stickyContent = sb.querySelector('.rb-sticky-content');
    if (!stickyContent) return setTimeout(init, 500);

    /* Appliquer le fond gradient sur cette page uniquement */
    var bb = document.querySelector('#build-a-box');
    if (bb) {
      /* Injecter le keyframe si pas déjà présent */
      if (!document.getElementById('msv-eng-keyframes')) {
        var style = document.createElement('style');
        style.id = 'msv-eng-keyframes';
        style.textContent = '@keyframes hv-grad-eng{0%{background-position:0% 20%}18%{background-position:75% 0%}42%{background-position:100% 85%}67%{background-position:15% 100%}83%{background-position:60% 30%}100%{background-position:0% 20%}}';
        document.head.appendChild(style);
      }
      bb.style.cssText += 'background-color:#EBC9FF;background-image:linear-gradient(135deg,#d2007375,#f5e0ff,#d2007361);background-size:400% 400%;animation:hv-grad-eng 30s cubic-bezier(0.37,0,0.63,1) infinite;border-radius:2rem;margin:0 1rem;';
    }

    /* Ajouter le titre en haut de la page */
    if (bb && !document.getElementById('msv-eng-header')) {
      var header = document.createElement('div');
      header.id = 'msv-eng-header';
      header.style.cssText = 'padding:2rem 1.5rem 1rem;';
      header.innerHTML = '<a href="/products/ma-semaine-vege?step=calc" style="display:inline-flex;align-items:center;gap:0.3rem;font-size:1.1rem;font-weight:600;color:#3c3c3b;text-decoration:none;margin-bottom:0.5rem;padding:0.3rem 0;"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>Retour au calculateur</a><h2 style="font-size:2.2rem;font-weight:900;color:#3c3c3b;margin:0 0 0.4rem;line-height:1.1;">Dans votre box, il y aura...</h2><p style="font-size:1.2rem;line-height:1.5;color:#3c3c3b;margin:0;">Faites votre choix parmi nos nombreuses <strong>références surgelées</strong>. Engagement sur 3 envois.</p>';
      bb.insertBefore(header, bb.firstChild);
    }

    /* Vider le contenu natif */
    stickyContent.innerHTML = '';
    stickyContent.style.cssText = 'display:flex;flex-direction:column;gap:0.8rem;';

    /* Row 1 : fréquence */
    var freq = sf.querySelector('.rb-frequency-wrapper');
    if (freq) {
      var row1 = document.createElement('div');
      row1.style.cssText = 'display:flex;align-items:center;gap:0.5rem;width:100%;';

      var pill = document.createElement('div');
      pill.style.cssText = 'display:flex;align-items:center;gap:0.5rem;border:1.5px solid #009819;border-radius:50rem;padding:0.4rem 0.5rem 0.4rem 1rem;flex:1;min-width:0;';
      pill.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#009819" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink:0"><path d="M12 2L3 7v5c0 5.25 3.75 10.15 9 11.25C17.25 22.15 21 17.25 21 12V7L12 2z"></path><line x1="12" y1="8" x2="12" y2="16"></line><line x1="8" y1="12" x2="16" y2="12"></line><line x1="9.5" y1="9.5" x2="14.5" y2="14.5"></line><line x1="14.5" y1="9.5" x2="9.5" y2="14.5"></line></svg><span style="font-size:1rem;font-weight:700;color:#009819;white-space:nowrap">Livraison surgelée tous les</span>';

      var sel = freq.querySelector('select');
      if (sel) {
        sel.style.cssText = 'border:none;background:#f0f0f0;border-radius:50rem;padding:0.4rem 1.5rem 0.4rem 0.8rem;font-size:1.1rem;font-weight:700;color:#3c3c3b;margin:0;cursor:pointer;';
        /* Simplifier le texte des options : "Livraison tous les X Mois" → "X mois" */
        Array.from(sel.options).forEach(function(opt) {
          var txt = opt.textContent.trim();
          var m = txt.match(/(\d+)\s*Mois/i);
          if (m) opt.textContent = m[1] + ' mois';
        });
        pill.appendChild(sel);
      }
      row1.appendChild(pill);
      stickyContent.appendChild(row1);
    }

    /* Row 2 : bouton CTA style msv-cart-btn */
    var row2 = document.createElement('div');
    row2.style.cssText = 'width:100%;';

    var nativeBtn = sf.querySelector('.rb-btn:not(.rb-btn-qty)');

    var btn = document.createElement('button');
    btn.id = 'msv-eng-cta';
    btn.disabled = true;
    btn.style.cssText = 'display:flex;align-items:center;justify-content:space-between;width:100%;padding:1.2rem 1.5rem;background:#e0e0e0;color:#999;border:none;border-radius:50rem;font-size:1.4rem;font-weight:700;cursor:pointer;font-family:inherit;transition:background 0.2s;';

    var btnText = document.createElement('span');
    btnText.id = 'msv-eng-cta-text';
    btnText.textContent = 'Choisissez vos produits';

    var btnArrow = document.createElement('span');
    btnArrow.style.cssText = 'display:flex;align-items:center;justify-content:center;width:28px;height:28px;background:rgba(255,255,255,0.25);border-radius:50%;flex-shrink:0;';
    btnArrow.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 6 15 12 9 18"></polyline></svg>';

    btn.appendChild(btnText);
    btn.appendChild(btnArrow);
    btn.onclick = function() { if (nativeBtn && !nativeBtn.disabled) nativeBtn.click(); };
    row2.appendChild(btn);
    stickyContent.appendChild(row2);

    /* Update dynamique */
    function update() {
      var inputs = w.querySelectorAll('.rb-input');
      var t = 0;
      inputs.forEach(function(i) { t += parseInt(i.value, 10) || 0; });

      var bb = document.querySelector('#build-a-box');
      var priceEl = bb ? bb.querySelector('.rb-heading .rb-price .tfw7') : null;
      var p = priceEl ? priceEl.textContent.trim() : '';

      var ctaText = document.getElementById('msv-eng-cta-text');
      var cta = document.getElementById('msv-eng-cta');
      if (!ctaText || !cta) return;

      if (t === 0) {
        ctaText.textContent = 'Choisissez vos produits';
        cta.disabled = true;
        cta.style.background = '#e0e0e0';
        cta.style.color = '#999';
      } else {
        /* Lire les 2 prix séparément */
        var oldPriceEl = bb ? bb.querySelector('.rb-heading .rb-full-price') : null;
        var oldPrice = oldPriceEl ? oldPriceEl.textContent.trim() : '';
        /* p = prix actuel complet, extraire juste le dernier montant */
        var prices = p.match(/[\d,.]+\s*€/g) || [];
        var actualPrice = prices.length > 0 ? prices[prices.length - 1].trim() : p;
        var priceHtml = '';
        if (oldPrice && oldPrice !== actualPrice) {
          priceHtml = '<s style="opacity:0.5;font-weight:400">' + oldPrice + '</s> ' + actualPrice;
        } else {
          priceHtml = actualPrice;
        }
        ctaText.innerHTML = t + ' produit' + (t > 1 ? 's' : '') + ' | ' + priceHtml + ' / envoi';
        cta.disabled = false;
        cta.style.background = '#009819';
        cta.style.color = '#fff';
      }
    }
    setInterval(update, 500);

    /* Ajouter le nom de variante au titre (comme sur /products/ma-semaine-vege) */
    fetch('/products.json?limit=250').then(function(r) { return r.json(); }).then(function(res) {
      var products = res.products || [];
      /* Map variant_id → variant_title ET product_id → first variant title */
      var varMap = {};
      var prodMap = {};
      products.forEach(function(p) {
        var firstVarTitle = null;
        (p.variants || []).forEach(function(v) {
          var t = v.title;
          if (t && t !== 'Default Title' && t !== 'Default Variant') {
            varMap[String(v.id)] = t;
            if (!firstVarTitle) firstVarTitle = t;
          }
        });
        if (firstVarTitle) prodMap[String(p.id)] = firstVarTitle;
      });

      function appendVariants() {
        var items = document.querySelectorAll('#recharge-bundles .rb-item[data-rb-item-id]');
        items.forEach(function(card) {
          if (card.dataset.msvVarDone) return;
          var sel = card.querySelector('.rb-variant-selector');
          if (sel) { card.dataset.msvVarDone = '1'; return; }
          var titleSpan = card.querySelector('.rb-title span');
          if (!titleSpan) return;
          if (titleSpan.textContent.indexOf('—') > -1) { card.dataset.msvVarDone = '1'; return; }

          var itemId = card.dataset.rbItemId;
          /* Essayer variant_id d'abord, puis product_id */
          var label = varMap[itemId] || prodMap[itemId];
          if (label) {
            titleSpan.textContent = titleSpan.textContent.trim() + ' — ' + label;
          }
          card.dataset.msvVarDone = '1';
        });
      }
      setTimeout(appendVariants, 2000);
      setTimeout(appendVariants, 4000);
    }).catch(function() {});
  }
  init();
})();
